export default "__VITE_ASSET__qn8BLW4n__"